<div class="w-100">

    <!-- tabs -->
    <div class="d-flex">
        <div *ngFor="let tab of this.getTabs(); let i=index" 
            class="tab-item th-input-border d-flex align-items-center justify-content-center" 
            [ngClass]="{
                'th-bg-white' : tab === getSelectedTab(),
                'inactive-tab' : tab !== getSelectedTab(),
                'first-tab': i === 0,
                'last-tab': i === this.getTabs().length - 1,
                'flex-fill': this.isExtraSmall,
                'medium-tab-item': !this.isExtraSmall
            }"
            (click)="changeTab(tab.getId())">
            <span [class]="this.getContentItemColor(tab)" class="fw-bold">{{tab.getTitle()}} {{tab.getTitleComplement()}}</span>
        </div>
    </div>

    <!-- content -->
    <div class="w-100 th-bg-white tab-item-content-container pt-4 pb-4">
        <ng-container #target></ng-container>
    </div>
</div>